import React, { useState } from "react";

import metaIQApi from "apis/metaIQ";
import {
  Pane,
  Steps,
  Button,
  Typography,
} from "components/Common/clearsense-ui/components";
import {
  DoneCheck,
  Eye,
  LeftMinimalArrow,
  RightMinimalArrow,
} from "components/Common/clearsense-ui/icons";
import { useMetaIQState } from "contexts/metaIQ";

import { DATABASE_DETAILS } from "./constants";

const Verify = ({ setStep, onClose, fetchDatabaseDetails }) => {
  const { categories, databaseDetails } = useMetaIQState();
  const [submitting, setSubmitting] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const selectedCategories = categories
        .filter(category => category.selected)
        .map(category => category.value);
      const response = await metaIQApi.createRequest(selectedCategories, {
        ...databaseDetails,
      });

      await metaIQApi.create({
        db_name: databaseDetails.db_name,
        db_type: databaseDetails.db_type,
        db_schema: databaseDetails.db_schema,
        audit_id: response.data.audit_id,
        classification_name: databaseDetails.classification_name,
        categories: selectedCategories,
      });
    } catch (error) {
      logger.error(error);
    } finally {
      onClose();
      fetchDatabaseDetails();
      setStep("categories");
      setSubmitting(false);
    }
  };

  const hidePassword = password =>
    Array(password ? password.length : 0).fill("*");

  return (
    <div>
      <Pane.Body className="py-2">
        <Steps
          className="mb-6"
          currentStep={2}
          steps={[
            <Typography key="categories" onClick={() => setStep("categories")}>
              Categories
            </Typography>,
            <Typography
              key="database_details"
              onClick={() => setStep("database details")}
            >
              Database Details
            </Typography>,
            <Typography key="verify">Verify</Typography>,
          ]}
        />
        <div className="flex flex-col space-y-4 w-full">
          <Typography style="h4" type="semibold">
            Selected Categories
          </Typography>
          <div className="h-44 overflow-y-auto">
            {categories
              .filter(category => category.selected)
              .map(category => (
                <Typography
                  className="border-t py-4 px-2 flex justify-between bg-gray-100"
                  key={category.value}
                >
                  <Typography className="text-indigo-500 font-semibold">
                    {category.value}
                  </Typography>
                  <DoneCheck className="text-indigo-500" />
                </Typography>
              ))}
          </div>
          <Typography style="h4" type="semibold">
            Connected Database
          </Typography>
          <div>
            {DATABASE_DETAILS.map(databaseDetail => (
              <Typography
                className="border-b p-2 flex space-x-2"
                key={databaseDetail.value}
              >
                <Typography className="text-gray-400">
                  {databaseDetail.label}
                </Typography>
                {databaseDetail.value === "db_pass" ? (
                  <Typography className="flex items-center">
                    <Typography className="text-indigo-500">
                      {isPasswordVisible
                        ? databaseDetails.db_pass
                        : hidePassword(databaseDetails.db_pass)}
                    </Typography>
                    <Eye
                      size={16}
                      className="text-indigo-500 ml-10"
                      onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                    />
                  </Typography>
                ) : (
                  <Typography className="text-indigo-500">
                    {databaseDetails[databaseDetail.value]}
                  </Typography>
                )}
              </Typography>
            ))}
          </div>
        </div>
      </Pane.Body>
      <Pane.Footer>
        <div className="flex justify-between w-full ">
          <Button
            label="Cancel"
            style="secondary"
            onClick={onClose}
            disabled={submitting}
          />
          <div className="flex space-x-2">
            <Button
              label="Previous"
              icon={LeftMinimalArrow}
              style="secondary"
              disabled={submitting}
              onClick={() => setStep("database details")}
            />
            <Button
              label="Submit"
              icon={RightMinimalArrow}
              iconPosition="right"
              loading={submitting}
              disabled={submitting}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </Pane.Footer>
    </div>
  );
};

export default Verify;
